import React from "react";
import { CheckmarkCircleSmIcon } from "../../../assets/icons";
import styles from "./StepSuccessCard.module.scss";

export interface StepSuccessCardProps {
	text: string;
}

export const StepSuccessCard: React.FC<StepSuccessCardProps> = ({ text }) => (
	<div className={styles.card}>
		<CheckmarkCircleSmIcon />
		<span className={styles.text}>{text}</span>
	</div>
);

export default StepSuccessCard;
